module.exports = __webpack_public_path__ + "static/media/kaufmannbausysteme.d3c561de.png";